// Analytics helper for tracking extended data alongside Algolia events

export const trackSearchClick = (algoliaData, extendedData) => {
  // Send to Google Analytics if available
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", "search_result_click", {
      search_term: algoliaData.query,
      content_type: extendedData.contentType,
      item_id: extendedData.slug,
      position: algoliaData.position,
      query_id: algoliaData.queryID,
      page_location: extendedData.url,
    })
  }

  // Send to Google Tag Manager if available
  if (typeof window !== "undefined" && window.dataLayer) {
    window.dataLayer.push({
      event: "algolia_search_click",
      algolia_object_id: algoliaData.objectID,
      algolia_query_id: algoliaData.queryID,
      algolia_position: algoliaData.position,
      search_query: algoliaData.query,
      content_slug: extendedData.slug,
      content_url: extendedData.url,
      content_type: extendedData.contentType,
      content_title: extendedData.title,
    })
  }
}

export const trackRecommendationClick = (item) => {
  if (typeof window !== "undefined" && window.dataLayer) {
    window.dataLayer.push({
      event: "recommendation_click",
      recommendation_title: item.title,
      recommendation_url: item.url,
    })
  }
}

export const trackSearchQuery = (query, resultsCount = 0) => {
  // Send to Google Tag Manager
  if (typeof window !== "undefined" && window.dataLayer) {
    window.dataLayer.push({
      event: "search_query",
      search_query: query,
      search_query_length: query.length,
      search_results_count: resultsCount,
      timestamp: new Date().toISOString(),
    })
  }

  // Send to Google Analytics if available
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", "search", {
      search_term: query,
      event_category: "search",
      event_label: "search_query",
      value: resultsCount,
    })
  }
}
